import React from 'react';
import proptypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames/bind';
import { getCreativeId } from '../../utils/helpers';
import styles from '../SponsoredBanner/SponsoredBanner.module.scss';
import { HOMEPAGE_BORDER_RADIUS } from '../../constants/constants.js';

const {
  string, bool, shape, object, number
} = proptypes;

let cx = classNames.bind(styles);
const SponsoredUniversalBannerCreative = ({
  schemaId,
  showBanner,
  bannerType,
  data,
  enableRoundedCorners = false,
  borderRadius
}) => {

  const { ref, clickID } = useImpression({
    data: {
      id: '00DEFVALSPB00',
      name: bannerType,
      component: 'SponsoredUniversalBanner',
      type: 'sponsoredcontent',
      campaignId: data?.sponsored?.banner?.campaignId,
      slotId: data?.sponsored?.banner?.slotId?.toString(),
      placementId: data?.sponsored?.banner?.placementId,
      flightId: data?.sponsored?.banner?.flightId,
      sponsoredId: data?.sponsored?.banner?.adRequestId,
      creativeId: getCreativeId(data?.sponsored?.banner?.bannerURL),
      category: '',
      position: 2,
    }
  });
  return (
    <div>
      {
        showBanner && (
          <div
            ref={ref} // eslint-disable-next-line react/no-unknown-property
            clickid={clickID}
            id={schemaId}
            data-testid={`sponsored-${bannerType}-banner`}
            className={cx(`sponsored_${bannerType}_banner`, { 'sui-rounded-xl sui-overflow-hidden': enableRoundedCorners })}
            data-ubc="true"
            data-border-radius={borderRadius}
            data-enable-rounded-corners={enableRoundedCorners}
          />
        )
      }
    </div>
  );
};

const propTypes = {
  schemaId: string,
  bannerType: string,
  enableRoundedCorners: bool,
  borderRadius: number,
  showBanner: bool,
  data: shape({
    sponsored: shape({
      banner: shape({
        campaignId: string,
        slotId: string,
        placementId: string,
        flightId: string,
        adRequestId: string,
        bannerURL: string,
      }),
    }),
  }),
};

const defaultProps = {
  schemaId: '',
  bannerType: '',
  enableRoundedCorners: false,
  borderRadius: HOMEPAGE_BORDER_RADIUS,
  showBanner: false,
  data: {
    sponsored: {
      banner: {
        campaignId: '',
        slotId: '',
        placementId: '',
        flightId: '',
        adRequestId: '',
        bannerURL: '',
      },
    },
  },
};

SponsoredUniversalBannerCreative.propTypes = propTypes;
SponsoredUniversalBannerCreative.defaultProps = defaultProps;

export { SponsoredUniversalBannerCreative };
